// src/pages/BalanceSheet/components/balanceSheetExportRows.js
// Maps the Balance Sheet table data to the shared financial-report export rows
// (Zoho-style vertical layout: Assets first, then Liabilities & Equity).

const GRAND_TOTAL_KEYS = ["assetsTotal", "liabilityTotal"];

const mapGroup = (groupLabel, items) => [
  { label: groupLabel, level: 0, style: "heading" },
  ...items.map((r) => {
    if (r.isSection) return { label: r.label, level: 1, style: "heading" };
    if (GRAND_TOTAL_KEYS.includes(r.key)) {
      return { label: r.label, value: r.value ?? 0, level: 0, style: "grand", blankAfter: true };
    }
    if (r.strong) {
      return { label: r.label, value: r.value ?? 0, level: 1, style: "total", blankAfter: true };
    }
    return { label: r.label, value: r.value ?? 0, level: 2, style: "item" };
  }),
];

export const toBalanceSheetExportRows = ({ assets, liabilities }) => [
  ...mapGroup("Assets", assets),
  ...mapGroup("Liabilities & Equity", liabilities),
];
